import React from 'react';
import { connect } from 'react-redux';

import TableWidgetResourceLibrary from '../../../../../cyder/table/TableWidgetResourceLibrary';

const MemberResourcesReports = ({ reports }) => <TableWidgetResourceLibrary items={reports} />;

export default MemberResourcesReports;
